<template>
  <v-text-field
    v-on="$listeners"
    v-bind="{ ...$attrs, ...$props }"
    :label="label"
    :rules="rules"
    single-line
    hide-spin-buttons
    type="number"
  />
</template>

<script>
import ValidationRules from '@/constants/ValidationRules'
export default {
  name: 'AdminInputNumber',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: 'Edit',
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {
    rules() {
      let rules = [ValidationRules.unsignedNumberRule]
      if (this.min) {
        rules.push(
          (v) =>
            Number(v) >= Number(this.min) ||
            `Enter a number greater than ${this.min}`
        )
      }
      if (this.max) {
        rules.push(
          (v) =>
            Number(v) <= Number(this.max) ||
            `Enter a number less than ${this.max}`
        )
      }
      return rules
    },
  },
}
</script>
